<div class="page-container">
  <app-toolbar [title]="'ACTIVITY_LOG.TITLE' | translate"></app-toolbar>
  <div class="page">
    <div class="activity-log">
      @if (view$ | async; as view) {
        <!-- Read before the table rather than under it: what the rows do not say is only worth
             knowing before conclusions have been drawn from them. -->
        @if (view.gaps.length > 0) {
          <button type="button" class="coverage-gap" (click)="showGaps()">
            <mat-icon fontIcon="info"></mat-icon>
            <span>{{ view.gapMessageKey | translate: { count: view.gaps.length } }}</span>
            <span class="coverage-gap-link">{{ 'ACTIVITY_LOG.COVERAGE.GAP_LINK' | translate }}</span>
          </button>
        }

        <app-table
          [source]="source"
          [columns]="view.columns"
          [rowId]="rowId"
          [pageSize]="defaultPageSize"
          [defaultSort]="defaultSort"
          [selectable]="false"
          [syncUrl]="true"
          tableId="activity-log"
          csvFilename="activity-log"
          label="ACTIVITY_LOG.TITLE"
          rowNoun="ACTIVITY_LOG.PAGINATION.ENTRY"
          rowNounPlural="ACTIVITY_LOG.PAGINATION.ENTRIES"
        />

        <!-- Without this an empty result reads as "it never happened" rather than as "we were not
             recording it yet", which for an audit log is the more consequential of the two. -->
        <div class="coverage" #coverage>
          <div class="coverage-summary">
            <mat-icon fontIcon="history"></mat-icon>
            <span>{{ 'ACTIVITY_LOG.COVERAGE.SUMMARY' | translate: { date: view.loggingSince } }}</span>
            @if (view.coverageRows.length > 0) {
              <button type="button" class="text-button" [attr.aria-expanded]="isCoverageOpen" (click)="toggleCoverage()">
                {{ (isCoverageOpen ? 'ACTIVITY_LOG.COVERAGE.HIDE' : 'ACTIVITY_LOG.COVERAGE.SHOW') | translate }}
              </button>
            }
          </div>

          @if (isCoverageOpen) {
            <table class="coverage-table" [attr.aria-label]="'ACTIVITY_LOG.COVERAGE.SHOW' | translate">
              <thead>
                <tr>
                  <th scope="col">{{ 'ACTIVITY_LOG.ACTION' | translate }}</th>
                  <th scope="col">{{ 'ACTIVITY_LOG.COVERAGE.RECORDED_SINCE' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of isCoverageNarrowed ? view.gaps : view.coverageRows; track row.action) {
                  <tr>
                    <td>{{ row.action }}</td>
                    <td>{{ row.recordedSince }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      }
    </div>
  </div>
</div>
